export default class FlashMessage {
	constructor() {
        this.flashMessage = document.querySelector('[data-flash-close]');
        if (this.flashMessage) {
            this.flashMessage.addEventListener('click', function(){
                this.remove();
            });

            setTimeout(e => {
                this.flashMessage.remove();
            }, 5000);
        }
    }
}